
// Libraries
import moment from 'moment';

// Components
import DropzoneFileUpload from '../Inputs/DropzoneFileUpload';
import RotaForm from '../Forms/RotaForm';
import LocationIcon from '../LocationIcon';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// Services
import RetailerLeadsService from '../../services/RetailerLeadsService';
import CharityLeadsService from '../../services/CharityLeadsService';
import RetailersService from '../../services/RetailersService';
import CharitiesService from '../../services/CharitiesService';
import UsersService from '../../services/UsersService';
import ContractsService from '../../services/ContractsService';
import UploadsService from '../../services/UploadsService';
import S3Service from '../../services/S3Service';
import Config from '../../services/Config';

// Utils
import DistanceUtils from '../../util/DistanceUtils';

// Utils
import days from '../../util/days-of-the-week';
let psAddRetailer;
let psAddBranch;

export default {
  name: 'onboarding',

  components: {
    DropzoneFileUpload,
    RotaForm,
    flatPicker,
    LocationIcon
  },

  props:[
    'leadType',
    'leadTypePlural',
    'userGroup',
  ],

  data() {
    return {
      mode: null,
      isSaving: false,

      leads: [],
      charities: [],
      retailers: [],
      branches: [],
      oppositeType: null,
      supplyOrDemand: null,
      selectedLead: null,
      selectedBranch: null,
      
      uploading: 0,

      addLead: {
        name: null,
        logoUrl: null,
        address_line_1: null,
        address_line_2: null,
        address_city: null,
        address_county: null,
        address_postcode: null,
        leadContact: {
          firstName: null,
          lastName: null,
          email: null,
          phone: null,
          position: null
        },
      },
      
      addLeadFileLogo: null,
      addLeadFilesToUpload: [],

      // Input is for putting into the RotaForm component
      availabilityPeriodsInput:{
        periods:[]
      },

      // Input is for recieving from the RotaForm component to save
      availabilityPeriodsOutput:{
        periods:[]
      },

      addBranch: {
        visible: false,
        name: null,
        address_line_1: null,
        address_line_2: null,
        address_city: null,
        address_county: null,
        address_postcode: null,
        description: null,
        dropInstructions: null,
        lat: null,
        lng: null,
        leadContact: {
          firstName: null,
          lastName: null,
          email: null,
          phone: null,
          position: null
        },
        filesToUpload: []
      },

      currentContracts:[],
      newContracts:[],

      uploadedFiles: [],
      fileCategories: {
        'contract': 'Contract',
        'allergen-information': 'Allergy Information',
        'food-information': 'Food Information',
        'partnership-agreement': 'Partnership Agreement',
        'charity-registration': 'Charity Registration',
        'health-and-safety-compliance': 'Health & Safety Compliance',
        'fridge-image': 'Fridge Image',
      },

      previewTemplate: null,
      previewTemplateBranch: null
    };
  },

  created() {
    this.init()
  },

  mounted() {

  },

  methods: {
    async init() {
      // Fetch leads
      try {
        // Retailer Onboarding
        if(this.leadType == 'Retailer'){
          this.oppositeType = 'charity';
          this.supplyOrDemand = 'supply';
          let res = await RetailerLeadsService.getAll();
          this.leads = res.data;
        
          res = await CharitiesService.getAll({});
          this.charities = res.data;
        // Charity Onboarding
        } else {
          this.oppositeType = 'retailer';
          this.supplyOrDemand = 'demand';
          let res = await CharityLeadsService.getAll();
          this.leads = res.data;

          this.updateRetailers();
        }
      }
      catch(err) {
        console.log('init.getAll()', {err});
      }

      this.initListScrollbars();
    },
    
    async updateRetailers(){
      let res = await RetailersService.getAll({});
      this.retailers = res.data;
    },

    onAddContractClick(event){
      this.newContracts.push(
        {
          charityId:undefined,
          startDate:new Date(),
          endDate:new Date(new Date().setFullYear(new Date().getFullYear()+5)),
          disabled:false
        });

      event.preventDefault();
      event.stopPropagation();
    },


    /**
     * 
     * @param {object} contract 
     */
    getBranchNameFromId(contract){
      if(this.leadType == 'Retailer'){
        let result = this.charities.find((c)=>{return c.id == contract.charityId});
        if(!result) result = {name:'Charity not found'}
        return result.name
      }else{
        let result = this.retailers.find((r)=>{return r.id == contract.retailerId});
        if(!result) result = {name:'Retailer not found'}
        return result.name;
      }
    },


    /**
     *  Clear the content in AddBranch
     */ 
    clearCurrentBranch(){
      this.addBranch = {
        visible: false,
        name: null,
        address_line_1: null,
        address_line_2: null,
        address_city: null,
        address_county: null,
        address_postcode: null,
        description: null,
        dropInstructions: null,
        lat: null,
        lng: null,
        leadContact: {
          firstName: null,
          lastName: null,
          email: null,
          phone: null,
          position: null
        },
        filesToUpload: []
      }
      this.currentContracts = [];
      this.newContracts = [];
      this.availabilityPeriodsInput = {periods:[]};
      this.availabilityPeriodsOutput = {periods:[]};
    },

    // Scrollbars
    initListScrollbars() {
      // setTimeout(() => {
      //   let psRetailer = new PerfectScrollbar('.scroll-lead');
      //   let psBranch = new PerfectScrollbar('.scroll-branch');
      // }, 500);
    },

    initAddLeadScrollbar() {
      // setTimeout(() => {
      //   psAddRetailer = new PerfectScrollbar('.scroll-add-lead');
      // }, 250);
    },

    initAddBranchScrollbar() {
      // setTimeout(() => {
      //   psAddBranch = new PerfectScrollbar('.scroll-add-branch');
      // }, 250);
    },

    destroyAddLeadScrollbar() {
      // if(psAddRetailer) {
      //   psAddRetailer.destroy();
      //   psAddRetailer = null;
      // }
    },

    destroyAddBranchScrollbar() {
      // if(psAddBranch) {
      //   psAddBranch.destroy();
      //   psAddBranch = null;
      // }
    },

    // Retailer & Branch Lists
    // -------------------------------

    /**
   * A Lead has been selected
   * @param {object} lead the lead selected
   */
    async selectLead(lead) {
      this.uploadedFiles = [];
      this.selectedLead = lead;
      this.selectedBranch = null;

      // Get branches for this lead
      try {
        let res = null;
        // Retailer
        if(this.leadType == 'Retailer'){
          res = await RetailersService.getAll({retailerLeadId: this.selectedLead.id});  

          // Get lead contact (user) for this retailer lead
          let userRes = await UsersService.getAll({where:{ group: 'retailerLead', groupEntityId: lead.id }});

          if(userRes.data.length > 0) {
            this.selectedLead.leadContact = {
              id: userRes.data[0].id,
              firstName: userRes.data[0].firstName,
              lastName: userRes.data[0].lastName,
              email: userRes.data[0].email,
              phone: userRes.data[0].contactTelephone,
              position: userRes.data[0].position
            };
          }
        }
        // Charity
        else{
          res = await CharitiesService.getAll({charityLeadId: this.selectedLead.id});  

          // Get lead contact (user) for this retailer lead
          let userRes = await UsersService.getAll({where:{ group: 'charityLead', groupEntityId: lead.id }});

          if(userRes.data.length > 0) {
            this.selectedLead.leadContact = {
              id: userRes.data[0].id,
              firstName: userRes.data[0].firstName,
              lastName: userRes.data[0].lastName,
              email: userRes.data[0].email,
              phone: userRes.data[0].contactTelephone,
              position: userRes.data[0].position
            };
          }
        }
        this.branches = res.data;
      }
      catch(err) {
        alert('Oops! Something went wrong, please try again...');
        console.log('Get all branches err', {err});
      }

      // Get this lead
      this.addLead = this.selectedLead
      this.addLeadFileLogo = null;

      this.mode = 'editLead';
      
      requestAnimationFrame(() => {
        if(this.$refs.previewTemplate) {
          this.previewTemplate = this.$refs.previewTemplate;
        }
      });
      
      // Reset the dropzone
      if(this.$refs.dropzone) {
        requestAnimationFrame(this.$refs.dropzone.reset);
      }

      // Get already uploaded files
      this.getUploadedFiles();
    },

    /**
     * @param {int} contractId 
     */
    async onContractDeleteClick(contractId){
      try{
        if(confirm('This contract will be immediately disabled are you sure you want to disable this contract?')){
          await ContractsService.update(contractId, {disabled: true});
          await this.updateRetailers();
          this.selectBranch(this.selectedBranch);
        }
      }catch(error){
        alert('Oops! Something went wrong, please try again...');
      }
    },

    /**
     * A Branch has been selected
     * @param {object} branch the branch selected
     */
    async selectBranch(branch) {
      this.uploadedFiles = [];
      this.selectedBranch = null;

      try {
        // Get availability periods
        let apRes = null
        // Retailer
        if(this.leadType == 'Retailer'){
          apRes = await RetailersService.getAvailabilityPeriods(branch.id);
        }
        // Charity
        else{
          apRes = await CharitiesService.getAvailabilityPeriods(branch.id);
        }
        this.availabilityPeriodsInput.periods = apRes.data;


        // Get user
        let userRes = await UsersService.getAll({where:{ group: this.userGroup, groupEntityId: branch.id }});
        
        let contractsRes = null;
        // Retailer
        if(this.leadType == 'Retailer'){
          contractsRes = await ContractsService.getAll({retailerId:branch.id, disabled:false});
        }
        // Charity
        else{
          contractsRes = await ContractsService.getAll({charityId:branch.id, disabled:false});
        }

        this.currentContracts = contractsRes.data;
        
        if(userRes.data.length == 0) {
          alert('Oops! Something went wrong, please try again...');
          return;
        }

        this.addBranch.leadContact = {
          id: userRes.data[0].id,
          firstName: userRes.data[0].firstName,
          lastName: userRes.data[0].lastName,
          email: userRes.data[0].email,
          phone: userRes.data[0].contactTelephone,
          position: userRes.data[0].position
        };

        // Get lead branch
        let branchRes = null;
        // Retailer
        if(this.leadType == 'Retailer'){
          branchRes = await RetailersService.getById(branch.id);
        }
        // Charity
        else{
          branchRes = await CharitiesService.getById(branch.id);
        }

        this.addBranch.visible = branchRes.data.visible;
        this.addBranch.name = branchRes.data.name;
        this.addBranch.address_line_1 = branchRes.data.address_line_1;
        this.addBranch.address_line_2 = branchRes.data.address_line_2;
        this.addBranch.address_city = branchRes.data.address_city;
        this.addBranch.address_county = branchRes.data.address_county;
        this.addBranch.address_postcode = branchRes.data.address_postcode;
        this.addBranch.description = branchRes.data.description;
        if(this.leadType == 'Charity') this.addBranch.dropInstructions = branchRes.data.dropInstructions;
        this.addBranch.lat = branchRes.data.lat;
        this.addBranch.lng = branchRes.data.lng;
        this.addBranch[this.supplyOrDemand + 'Monday'] = branchRes.data[this.supplyOrDemand + 'Monday'];
        this.addBranch[this.supplyOrDemand + 'Tuesday'] = branchRes.data[this.supplyOrDemand + 'Tuesday'];
        this.addBranch[this.supplyOrDemand + 'Wednesday'] = branchRes.data[this.supplyOrDemand + 'Wednesday'];
        this.addBranch[this.supplyOrDemand + 'Thursday'] = branchRes.data[this.supplyOrDemand + 'Thursday'];
        this.addBranch[this.supplyOrDemand + 'Friday'] = branchRes.data[this.supplyOrDemand + 'Friday'];
        this.addBranch[this.supplyOrDemand + 'Saturday'] = branchRes.data[this.supplyOrDemand + 'Saturday'];
        this.addBranch[this.supplyOrDemand + 'Sunday'] = branchRes.data[this.supplyOrDemand + 'Sunday'];

        this.selectedBranch = branch;

        this.mode = 'editBranch';

        // Get already uploaded files
        this.getUploadedFiles();
        
        requestAnimationFrame(() => {
          if(this.$refs.previewTemplateBranch) {
            this.previewTemplateBranch = this.$refs.previewTemplateBranch;
          }
        });

        // Reset the dropzone
        if(this.$refs.dropzoneBranch) {
          requestAnimationFrame(this.$refs.dropzoneBranch.reset);
        }
      }
      catch(err) {
        console.log('Onboarding.selectBranch()', {err});
      }
    },

    // Add lead
    // --------------------
    showAddLead() {
      this.addLead = {
        name: null,
        logoUrl: null,
        address_line_1: null,
        address_line_2: null,
        address_city: null,
        address_county: null,
        address_postcode: null,
        leadContact: {
          firstName: null,
          lastName: null,
          email: null,
          phone: null,
          position: null
        },
      };
      
      this.addLeadFilesToUpload = [];
      this.addLeadFileLogo = null;
      this.uploadedFiles = [];
      this.selectedLead = null;
      this.mode = 'addLead';
      
      requestAnimationFrame(() => {
        if(this.$refs.previewTemplate) {
          this.previewTemplate = this.$refs.previewTemplate;
        }
      });
      
      // Reset the dropzone
      if(this.$refs.dropzone) {
        requestAnimationFrame(this.$refs.dropzone.reset);
      }

      this.initAddLeadScrollbar();
    },

    /**
     * Save a new lead retailer/charity
     */
    async saveLead() {
      // Match file upload categories fo file objects
      const fileEls = document.querySelectorAll('.js-branch-file');

      if(
        !this.addLead.name
        || !this.addLead.address_line_1
        // || !this.addLead.address_line_2
        || !this.addLead.address_city
        // || !this.addLead.address_county
        || !this.addLead.address_postcode
        || !this.addLead.leadContact.firstName
        || !this.addLead.leadContact.lastName
        || !this.addLead.leadContact.email
        // || !this.addLead.leadContact.phone
        // || !this.addLead.leadContact.position
      ) {
        alert('You must provide values for all required fields');
        return;
      }

      if(this.addLead.address_line_2 === null) this.addLead.address_line_2 ='';
      if(this.addLead.address_county === null) this.addLead.address_county ='';

      for(let fileEl of fileEls) {
        // Get filename
        const fileNameEl = fileEl.querySelector('[data-dz-name]');
        let fileName = fileNameEl.innerText;
        
        // Get file category
        let fileCategoryEl = fileEl.querySelector('.js-file-category');
        let fileCategory = fileCategoryEl.value;

        if(fileCategory === '') {
          alert('You must select a category for all file uploads before saving.');
          return;
        }

        // Add category to matched file in this.addBranch.filesToUpload
        let fileMatch = this.addLeadFilesToUpload.find(f => f.name === fileName);
        fileMatch.category = fileCategory;
      };

      console.log('Save Lead', this.leadType);

      if(!this.addLead.name || (this.addLead.name && !this.addLead.name.trim().length)) {
        alert('You must provide a ' + this.leadType + 'lead name');
        return;
      }

      if(!this.addLeadFileLogo && !this.addLead.logoUrl){
        alert('You must provide a ' + this.leadType + 'Logo');
        return;
      }
      
      this.isSaving = true;
      
      // New logo?
      if(this.addLeadFileLogo != null){
        try {
          const fileCategory = this.leadType.toLowerCase() + '-logos';
          const originalFileName = this.addLeadFileLogo[0].name;

          // Get Signed Url
          // -------------------------------------------------
          let data = {
            fileName: originalFileName,
            fileType: this.addLeadFileLogo[0].type,
            fileCategory: fileCategory,
          };

          let response = await UploadsService.signUpload(data);
          const signedUrl = response.data.signedRequest;
          const uniqueFileName = response.data.uniqueFilename;

          // Upload File to S3 using Signed Url
          // -------------------------------------------------
          let uploadResponse = await S3Service.uploadSignedUrl(signedUrl, this.addLeadFileLogo[0]);

          // Create Upload Entry on Backend
          // -------------------------------------------------
          let createData = {
            originalFileName: originalFileName,
            uniqueFileName: uniqueFileName,
            fileCategory: fileCategory
          };

          let createResponse = await UploadsService.createOne(createData);

          // Store the url for the new uploaded logo
          this.addLead.logoUrl = Config.s3Url + fileCategory + '/' + uniqueFileName;

          // Clear out the fileLogo element
          this.addLeadFileLogo = null;
        }
        catch(err) {
          alert('Oops! Something went wrong, please try again...');
          console.log('Image upload error', {err});
          
          this.isSaving = false;
        }
      }

      // Get the correct Service for this leadType
      let leadService = this.leadType == 'Retailer' ? RetailerLeadsService : CharityLeadsService;

      let leadId = null;

      if(this.mode === 'addLead') {
        try {
          this.isSaving = true;

          let userData = {
            firstName: this.addLead.leadContact.firstName,
            lastName: this.addLead.leadContact.lastName,
            email: this.addLead.leadContact.email,
            contactTelephone: this.addLead.leadContact.phone,
            position: this.addLead.leadContact.position,
            group: this.leadType === 'Retailer' ? 'retailerLead' : 'charityLead',
            suspended: false
          }

          // Create the User entry
          let userRes = await UsersService.createOne(userData);
          
          let leadRes = await leadService.createOne(this.addLead);
          
          leadId = leadRes.id;

          // Update the user with the retailer ID
          let userUpdateRes = await UsersService.update(userRes.data.id, { groupEntityId: leadRes.data.id });

          // Send activation email to new user
          if(this.leadType === 'Retailer'){
            let emailRes = await UsersService.sendActivationEmail(userRes.data.id);
          }
        }
        catch(err) {
          if(err.response.status === 409) {
            return alert('That email address is already in use, please try another...');
          }

          alert('Oops! Something went wrong, please try again...');
          console.log('SaveLead err', {err});

          this.isSaving = false;
        }
      }
      else if (this.mode === 'editLead') {
        try {
          let leadRes = await leadService.update(this.addLead.id, this.addLead);
          
          leadId = this.addLead.id;

          let userData = {
            firstName: this.addLead.leadContact.firstName,
            lastName: this.addLead.leadContact.lastName,
            email: this.addLead.leadContact.email,
            contactTelephone: this.addLead.leadContact.phone,
            position: this.addLead.leadContact.position
          }

          // Update the user with the retailer ID
          let userUpdateRes = await UsersService.update(this.addLead.leadContact.id, userData);
        }
        catch(err) {
          if(err.response.status === 409) {
            return alert('That email address is already in use, please try another...');
          }

          alert('Oops! Something went wrong, please try again...');
          console.log('SaveLead err', {err});

          this.isSaving = false;
        }
      }
      try {
        // Upload any files
        // -------------------------
        for(let file of this.addLeadFilesToUpload) {
          const originalFileName = file.name;

          // Get Signed Url
          // -------------------------------------------------
          let data = {
            fileName: originalFileName,
            fileType: file.type,
            fileCategory: file.category,
          };

          let response = await UploadsService.signUpload(data);
          const signedUrl = response.data.signedRequest;
          const uniqueFileName = response.data.uniqueFilename;

          // Upload File to S3 using Signed Url
          // -------------------------------------------------
          let uploadResponse = await S3Service.uploadSignedUrl(signedUrl, file);

          // Create Upload Entry on Backend
          // -------------------------------------------------
          let createData = {
            originalFileName: originalFileName,
            uniqueFileName: uniqueFileName,
            fileCategory: file.category,
            group: this.leadType.toLowerCase() === 'retailer' ? 'retailerLead' : 'charityLead',
            groupEntityId: leadId
          };

          let createResponse = await UploadsService.createOne(createData);
        }
      }
      catch(err) {
        alert('Oops! Something went wrong, please try again...');
        console.log('SaveLead:uploadFiles err', {err});

        this.isSaving = false;
      }

      // Refetch leads
      await this.init();

      this.destroyAddLeadScrollbar();
      this.mode = null;

      this.addLead = {
        name: null,
        fileLogo: null
      };

      this.isSaving = false;
    },

    // Add branch
    // ------------------------
    showAddBranch() {
      this.clearCurrentBranch();

      this.selectedBranch = null;
      this.mode = 'addBranch';

      requestAnimationFrame(() => {
        if(this.$refs.previewTemplateBranch) {
          this.previewTemplateBranch = this.$refs.previewTemplateBranch;
        }
      });

      // Reset the dropzone
      if(this.$refs.dropzoneBranch) {
        requestAnimationFrame(this.$refs.dropzoneBranch.reset);
      }

      this.initAddBranchScrollbar();
    },

    showAddVolunteer() {
      this.$router.push('/admin/volunteer/create')
    },
    /**
     * @param {object} rotaData Data from the rota form for supply and availability
     */
    onRotaUpdate(rotaData) {
      for (let index = 0; index < days.length; index++) {
        const day = days[index];
        this.addBranch[this.supplyOrDemand + day] = rotaData.quantities[index];
      }
      this.availabilityPeriodsOutput = { periods: rotaData.periods };
    },

    /**
     * Save a branch
     */
    async saveBranch() {
      // Match file upload categories fo file objects
      const fileEls = document.querySelectorAll('.js-branch-file');

      for(let fileEl of fileEls) {
        // Get filename
        const fileNameEl = fileEl.querySelector('[data-dz-name]');
        let fileName = fileNameEl.innerText;
        
        // Get file catgeory
        let fileCategoryEl = fileEl.querySelector('.js-file-category');
        let fileCategory = fileCategoryEl.value;

        if(fileCategory === '') {
          alert('You must select a category for all file uploads before saving.');
          return;
        }

        // Add category to matched file in this.addBranch.filesToUpload
        let fileMatch = this.addBranch.filesToUpload.find(f => f.name === fileName);
        fileMatch.category = fileCategory;
      };

      // Save branch
      console.log('Save Branch');
      if(
        !this.addBranch.name
        || !this.addBranch.address_line_1
        // || !this.addBranch.address_line_2
        || !this.addBranch.address_city
        // || !this.addBranch.address_county
        || !this.addBranch.address_postcode
        || !this.addBranch.description
        || !this.addBranch.leadContact.firstName
        || !this.addBranch.leadContact.lastName
        || !this.addBranch.leadContact.email
        // || !this.addBranch.leadContact.phone
        // || !this.addBranch.leadContact.position
        || !this.addBranch.lat
        || !this.addBranch.lng
      ) {
        alert('You must provide values for all required fields');
        return;
      }

      let emailRegExp =  	/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

      if(!emailRegExp.test(this.addBranch.leadContact.email)){
        alert('Please enter a valid email');
        return;
      }

      try {
        this.isSaving = true;

        let userData = {
          firstName: this.addBranch.leadContact.firstName,
          lastName: this.addBranch.leadContact.lastName,
          email: this.addBranch.leadContact.email,
          contactTelephone: this.addBranch.leadContact.phone,
          position: this.addBranch.leadContact.position,
          group: this.userGroup,
          suspended: false
        }

        let branchData = {
          visible: this.addBranch.visible,
          name: this.addBranch.name,
          address_line_1: this.addBranch.address_line_1,
          address_line_2: this.addBranch.address_line_2,
          address_city: this.addBranch.address_city,
          address_county: this.addBranch.address_county,
          address_postcode: this.addBranch.address_postcode,
          description: this.addBranch.description,
          [this.supplyOrDemand + 'Monday']: this.addBranch[this.supplyOrDemand + 'Monday'],
          [this.supplyOrDemand + 'Tuesday']: this.addBranch[this.supplyOrDemand + 'Tuesday'],
          [this.supplyOrDemand + 'Wednesday']: this.addBranch[this.supplyOrDemand + 'Wednesday'],
          [this.supplyOrDemand + 'Thursday']: this.addBranch[this.supplyOrDemand + 'Thursday'],
          [this.supplyOrDemand + 'Friday']: this.addBranch[this.supplyOrDemand + 'Friday'],
          [this.supplyOrDemand + 'Saturday']: this.addBranch[this.supplyOrDemand + 'Saturday'],
          [this.supplyOrDemand + 'Sunday']: this.addBranch[this.supplyOrDemand + 'Sunday'],
          lat: this.addBranch.lat,
          lng: this.addBranch.lng,
        }

        if(this.leadType === 'Retailer'){
          branchData.retailerLeadId = this.selectedLead.id;
        }else{
          branchData.charityLeadId = this.selectedLead.id;
          branchData.dropInstructions = this.addBranch.dropInstructions;
        }

        let branchId = null

        // Get the correct Service for this leadType
        let branchService = this.leadType == 'Retailer' ? RetailersService : CharitiesService;

        // Add Branch Mode
        if(this.mode === 'addBranch') {
          // Create the User entry
          let userRes = await UsersService.createOne(userData);

          // Create the branch entry
          let branchRes = await branchService.createOne(branchData);
          branchId = branchRes.data.id;

          // Create the availability periods
          let availabilityRes = await branchService.postAvailabilityPeriods(branchRes.data.id, this.availabilityPeriodsOutput);

          // Update the user with the retailer ID
          let userUpdateRes = await UsersService.update(userRes.data.id, { groupEntityId: branchRes.data.id });

          // Send activation email to new user
          let emailRes = await UsersService.sendActivationEmail(userRes.data.id);
        }
        // Edit Branch Mode
        else if (this.mode === 'editBranch') {
          let userRes = await UsersService.update(this.addBranch.leadContact.id, userData);
          let branchRes = await branchService.update(this.selectedBranch.id, branchData);
          branchId = this.selectedBranch.id;
          let availabilityRes = await branchService.postAvailabilityPeriods(this.selectedBranch.id, this.availabilityPeriodsOutput);
        }

        // Then create new contracts
        let contract = null;
        for (let index = 0; index < this.newContracts.length; index++) {
          let contract = this.newContracts[index];
          if(this.leadType == 'Retailer'){
            contract.retailerId = branchId;
          }else{
            contract.charityId = branchId;
          }
          await ContractsService.createOne(contract);
        }

        // Upload any files
        // -------------------------
        for(let file of this.addBranch.filesToUpload) {
          const originalFileName = file.name;

          // Get Signed Url
          // -------------------------------------------------
          let data = {
            fileName: originalFileName,
            fileType: file.type,
            fileCategory: file.category,
          };

          let response = await UploadsService.signUpload(data);
          const signedUrl = response.data.signedRequest;
          const uniqueFileName = response.data.uniqueFilename;

          // Upload File to S3 using Signed Url
          // -------------------------------------------------
          let uploadResponse = await S3Service.uploadSignedUrl(signedUrl, file);

          // Create Upload Entry on Backend
          // -------------------------------------------------
          let createData = {
            originalFileName: originalFileName,
            uniqueFileName: uniqueFileName,
            fileCategory: file.category,
            group: this.leadType.toLowerCase() === 'retailer' ? 'retailers' : 'charities',
            groupEntityId: branchId
          };
          let createResponse = await UploadsService.createOne(createData);
        }

        // Update the UI
        // -------------------------
        // Select retailer (also refreshes the branches for that retailer)
        this.selectLead(this.leads.find(r => r.id == this.selectedLead.id));

        // Reset the add retailer display and data
        // ---------------------------------------
        this.destroyAddLeadScrollbar();

        this.mode = null;

        this.clearCurrentBranch();

        this.isSaving = false;
      }
      catch(err) {
        console.log('SaveBranch err', {err});
        if(err.response && err.response.data && err.response.data.err_message) {
          alert(err.response.data.err_message);
        }
        else {
          alert('Oops! Something went wrong, please try again...');
        }

        this.isSaving = false;
      }
    },

    // Uploaded Files
    // ---------------------------
    async getUploadedFiles() {
      if(this.mode === 'editLead' && this.leadType && this.leadType === 'Retailer') {
        // Get retailer lead files
        let res = await UploadsService.getAll({
          group: 'retailerLead',
          groupEntityId: this.selectedLead.id,
        })
        this.uploadedFiles = res.data;
      }
      else if(this.mode === 'editLead' && this.leadType && this.leadType === 'Charity') {
        // Get charity lead files
        let res = await UploadsService.getAll({
          group: 'charityLead',
          groupEntityId: this.selectedLead.id,
        })
        this.uploadedFiles = res.data;
      }
      else if(this.mode === 'editBranch' && this.leadType && this.leadType === 'Charity') {
        // Get charity branch files
        let res = await UploadsService.getAll({
          group: 'charities',
          groupEntityId: this.selectedBranch.id,
        })
        this.uploadedFiles = res.data;
      }
    },

    async openUploadedFile(uploadId) {
      try {
        // Get the signed download url from S3
        let fileRes = await UploadsService.getSignedDownload(uploadId);
        const signedUrl = fileRes.data;
        
        // Open a new tab/window with the signed url
        window.open(signedUrl);
      }
      catch(err) {
        alert('Oops, something went wrong while getting the file. Please try again.')
      }
    },

    async deleteUploadedFile(uploadId) {
      if(confirm('Are you sure you want to delete this file?')) {
        try {
          await UploadsService.deleteById(uploadId);
  
          this.getUploadedFiles();
        }
        catch(err) {
          alert('Oops, something went wrong while deleting the file. Please try again.')
        }
      }
    },

    // Utils
    // ---------------------------
    timeAgo(date) {
      return moment().to(date);
    }
  },

  computed: {
    filteredContractRetailers() {
      if (!this.addBranch.lat || !this.addBranch.lng) {
        return this.retailers;
      }

      return this.retailers.filter((r) => {
        // if retailer is within range of our current branch, return true
        if(DistanceUtils.calculateDistanceBetweenPoints(this.addBranch.lat, this.addBranch.lng, r.lat, r.lng) < 3000) {
          return true;
        }

        return false;
      });
    },

    filteredContractCharities() {
      if (!this.addBranch.lat || !this.addBranch.lng) {
        return this.charities;
      }

      return this.charities.filter((c) => {
        // if retailer is within range of our current branch, return true
        if(DistanceUtils.calculateDistanceBetweenPoints(this.addBranch.lat, this.addBranch.lng, c.lat, c.lng) < 3000) {
          return true;
        }

        return false;
      });
    }
  }
};
